import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';

@Pipe({ name: 'canUploadSignedReport' })
export class CanUploadSignedReportPipe implements PipeTransform {
  transform(data: DprCard, isAppOnline: boolean, canEdit: boolean): boolean {
    return (
      data &&
      data.dprDetailsFirstWarning == null &&
      data.dprDetailLockedDate &&
      canEdit &&
      isAppOnline &&
      !data.hasActiveSignRequest
    );
  }
}
